import {inject, Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  private loaded = false;
  private scriptLoadingPromise: Promise<void> | null = null;
  rendererFactory = inject(RendererFactory2);
  renderer: Renderer2;

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  load(): Promise<void> {
    if (this.isLoaded()) {
      return Promise.resolve();
    }

    if (this.scriptLoadingPromise) {
      return this.scriptLoadingPromise;
    }

    this.scriptLoadingPromise = new Promise((resolve, reject) => {
      if (this.isLoaded()) {
        resolve();
        return;
      }

      const script = this.renderer.createElement('script');
      script.id = 'google-maps-script';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapKey}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.loaded = true;
        resolve();
      };
      script.onerror = (error: any) => {
        this.scriptLoadingPromise = null;
        reject(error);
      };
      this.renderer.appendChild(document.body, script);
    });

    return this.scriptLoadingPromise;
  }

  isLoaded(): boolean {
    return typeof google !== 'undefined' && !!google.maps;
  }
}
